<template>
  <div class="home">
    <div class="index-top">
      <img class="background" src="../../assets/web/g-ban.jpg" />
      <home-navbar></home-navbar>
    </div>

    <div class="index-middle">
      <img class="background" src="@/assets/web/background-middle.jpg" />

      <div class="content">
        <img src="../../assets/web/aboutlogo.png" />
        <p>
          湖南创新娱乐传媒有限公司是湖南广播电视台娱乐频道一体化运行公司，依托于湖南广播影视集团·大芒果生态,
          <br />布局综艺节目、大型活动、广告营销、内容制作、新媒体矩阵、短视频运营等全领域生态产品，创新媒体运营模
          <br />式，放大品牌传播价值，致力打造具有社会责任感和社会影响力的整合媒体和内容服务机构。
        </p>
      </div>
    </div>

    <div class="index-bottom">
      <img class="background" src="@/assets/web/background-bottom.jpg" />
      <div class="action">
        <img :src="prevArrow" @click="switchVideoFromArrows('prev')" />
        <img :src="nextArrow" @click="switchVideoFromArrows('next')" />
      </div>
      <dplayer ref="player" class="video-item" :options="videoOptions"></dplayer>
      <div class="title">
        <div class="number">{{videoTitle.number}}</div>
        <!-- <div class="name">{{videoTitle.name}}</div> -->
      </div>

      <div class="pagination">
        <div
          v-for="(soucre, index) in videosSources"
          :key="index"
          class="hots"
          :class="{active: currentIndex === index }"
          @click="switchVideoFromHots(index)"
        ></div>
      </div>
    </div>

    <div id="footer" class="footer" ref="footer">
      <div class="join-us">
        <p class="top">
          <img class="symbol begin" src="@/assets/symbol-begin.png" />
          <span class="title">加入我们</span>
          <span class="cutting-line"></span>
        </p>
        <p class="bottom">
          <span class="content">有梦当燃，向阳而造，期待志同道合的你</span>
          <img class="symbol end" src="@/assets/symbol-end.png" />
        </p>
      </div>

      <div class="contact-us">
        <div>
          <p class="top">
            <img class="icon-phone" src="@/assets/telephone-icon.png" />
            <span class="text">电话</span>
            <span class="shallow">/ telephone</span>
          </p>
          <p class="bottom">0731-84802287</p>
        </div>

        <div class="contact-us-middle">
          <p class="top">
            <img class="icon-mail" src="@/assets/mail-icon.png" />
            <span class="text">邮箱</span>
            <span class="shallow">/ mailbox</span>
          </p>
          <p class="bottom">mango@fulantv.com</p>
        </div>

        <div>
          <p class="top">
            <img class="icon-location" src="@/assets/address-icon.png" />
            <span class="text">地址</span>
            <span class="shallow">/ address</span>
          </p>
          <p class="bottom">湖南省长沙市开福区湖南电视台</p>
        </div>
      </div>

      <div class="archive">
        <img src="@/assets/ghs-icon.png" />
        <a href="http://www.beian.miit.gov.cn" target="_blank">湘ICP备20009389号-1</a>
      </div>
    </div>
  </div>
</template>

<script>
import VueDPlayer from "vue-dplayer";
import "vue-dplayer/dist/vue-dplayer.css";
import HomeNavbar from "@/partial/headbar";

export default {
  name: "home",
  components: {
    dplayer: VueDPlayer,
    HomeNavbar,
  },
  data() {
    return {
      currentIndex: 0,
      prevArrow: require("@/assets/arrow-prev.png"),
      nextArrow: require("@/assets/arrow-next.png"),
      videosSources: [
        {
          src: "http://webcdn.fulantv.com/website/video/launch_vcr.mp4",
          poster: require("@/assets/web/poster-1.jpg"),
          title: {
            number: "01",
            name: "创新娱乐启动仪式",
          },
        },
        {
          src: "http://webcdn.fulantv.com/website/video/mango_league.mp4",
          poster: require("@/assets/web/poster-2.jpg"),
          title: {
            number: "02",
            name: "创新娱乐启动仪式2",
          },
        },
        {
          src: "http://webcdn.fulantv.com/website/video/environment.mp4",
          poster: require("@/assets/web/poster-3.jpg"),
          title: {
            number: "03",
            name: "创新娱乐启动仪式3",
          },
        },
        {
          src: "http://webcdn.fulantv.com/website/video/480art_studio.mp4",
          poster: require("@/assets/web/poster-4.jpg"),
          title: {
            number: "04",
            name: "创新娱乐启动仪式4",
          },
        },
      ],
      videoOptions: {
        preload: "auto",
        logo: require("@/assets/play-btn.png"),
        video: {
          url: "http://webcdn.fulantv.com/website/video/launch_vcr.mp4",
          pic: require("@/assets/web/poster-1.jpg"),
        },
      },
    };
  },
  computed: {
    videoTitle() {
      return this.videosSources[this.currentIndex].title;
    },
  },
  created() {},
  mounted() {
    let vm = this;
    const player = vm.$refs.player.dp;
    if (player) {
      var playerDom = document.querySelector(".video-item");
      var logo = document.querySelector(".dplayer-logo");
      var mask = document.querySelector(".dplayer-controller-mask");

      if (this.isMobile()) {
        playerDom.addEventListener("click", function () {
          player.toggle();
        });
      }

      player.on("play", function () {
        console.log(123);
        logo.style.display = "none";
        mask.style.display = "none";
      });
      player.on("pause", function () {
        logo.style.display = "block";
        mask.style.display = "block";
      });
    }

    let isoffset = this.$route.query.isoffset;
    if (isoffset == 1) {
      let anchor = this.$refs.footer;
      document.documentElement.scrollTop = anchor.offsetTop;
    }
  },

  methods: {
    switchVideoFromArrows(type) {
      if (type === "prev") {
        if (this.currentIndex > 0) {
          this.currentIndex -= 1;
        } else {
          this.currentIndex = this.videosSources.length - 1;
        }
        this.prevArrow = require("@/assets/arrow-prev-light.png");
      } else {
        if (this.currentIndex < this.videosSources.length - 1) {
          this.currentIndex += 1;
        } else {
          this.currentIndex = 0;
        }
        this.nextArrow = require("@/assets/arrow-next-light.png");
      }
      setTimeout(() => {
        this.prevArrow = require("@/assets/arrow-prev.png");
        this.nextArrow = require("@/assets/arrow-next.png");
      }, 300);
      this.switchVideoFromHots(this.currentIndex);
    },

    switchVideoFromHots(index) {
      var logo = document.querySelector(".dplayer-logo");
      var mask = document.querySelector(".dplayer-controller-mask");
      const player = this.$refs.player.dp;
      this.currentIndex = index;
      player.switchVideo({
        url: this.videosSources[index].src,
        pic: this.videosSources[index].poster,
      });
      logo.style.display = "block";
      mask.style.display = "block";
    },
  },
};
</script>
<style lang="scss">
.home {
  .background {
    width: 100%;
  }

  .index-top {
    position: relative;
  }

  .index-middle {
    position: relative;

    .content {
      min-width: 600px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      margin: 0 auto;
      left: 0;
      right: 0;

      img {
        width: 33.125vw;
      }

      p {
        font-size: 1.146vw;
        height: 6.25vw;
        line-height: 2.5vw;
        margin-top: 7.6vw;
        font-family: PingFang-SC-Light;
        font-weight: 300;
        color: rgba(51, 51, 51, 1);
      }
    }
  }

  .index-bottom {
    position: relative;

    .action {
      position: absolute;
      top: 5vw;
      left: 24.583vw;

      img:first-child {
        margin-right: 1.042vw;
      }

      img {
        width: 3.125vw;
        height: 3.125vw;
      }
    }

    .video-item {
      position: absolute;
      /* width: 470px; */
      /* height: 266px; */
      /* top: 91px; */
      /* left: 236px; */
      top: 9.479vw;
      left: 24.479vw;
      width: 48.854vw;

      .dplayer-video-wrap > .dplayer-logo {
        position: absolute !important;
        top: 50% !important;
        transform: translateY(-50%) !important;
        left: 0 !important;
        right: 0 !important;
        margin: 0 auto !important;
        z-index: 1;

        img {
          width: 5vw;
        }
      }

      .dplayer-controller-mask {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        height: auto;
        background: rgba(0, 0, 0, 0.5);
      }

      .dplayer-controller {
        display: none;
      }
    }

    .title {
      position: absolute;
      bottom: 6.979vw;
      left: 25.521vw;
      display: flex;

      .number {
        width: 5.729vw;
        height: 5vw;
        font-size: 6.354vw;
        font-family: AvantGardeCE-Demi;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        line-height: 4.688vw;
        opacity: 0.3;
      }

      .name {
        margin-left: -2.5vw;
        font-size: 2.5vw;
        font-family: PingFang-SC-Bold;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        align-self: flex-end;
      }
    }

    .pagination {
      position: absolute;
      bottom: 1.354vw;
      left: 0;
      right: 0;
      margin: 0 auto;
      display: flex;
      justify-content: center;

      .hots {
        width: 0.938vw;
        height: 0.938vw;
        margin-right: 0.729vw;
        background: rgba(255, 255, 255, 1);
        opacity: 0.2;
        border-radius: 50%;
      }

      .active {
        opacity: 1;
      }
    }
  }

  .footer {
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: column;
    /* margin: 92px 170px 44px; */
    margin: 8.125vw 18.854vw;
    min-width: 700px;

    p {
      margin: 0 auto;
    }

    .join-us {
      text-align: left;

      .begin {
        position: absolute;
        bottom: 12px;
      }

      .end {
        position: absolute;
        top: 12px;
      }

      .top {
        position: relative;
        display: flex;
        align-items: center;

        .title {
          font-size: 24px;
          font-family: PingFang-SC-Medium;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          line-height: 30px;
          margin: 0 10px 0 42px;
        }

        .cutting-line {
          display: block;
          width: 37px;
          height: 2px;
          background: rgba(174, 174, 174, 1);
        }
      }

      .bottom {
        position: relative;
        margin-top: 16px;

        .content {
          font-size: 32px;
          font-family: PingFang-SC-Medium;
          font-weight: 500;
          color: #ffb129;
          line-height: 30px;
          margin: 0 12px 0 40px;
        }
      }
    }

    .contact-us {
      display: flex;
      justify-content: space-between;
      margin: 96px 0 60px;

      .top {
        display: flex;
        align-items: center;

        .text {
          margin: 0 8px 0 18px;
          font-size: 22px;
          font-family: PingFang-SC-Bold;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
        }
      }

      .bottom {
        text-align: left;
        margin: 16px 0 0 44px;
      }

      .shallow,
      .bottom {
        color: #333;
        font-size: 18px;
        font-family: PingFang-SC-Light;
        font-weight: 300;
      }
    }

    .archive {
      display: flex;
      align-items: center;

      img {
        width: 16px;
        height: 16px;
        margin: 0 12px 0 6px;
      }

      a {
        font-size: 14px;
        font-family: PingFang-SC-Regular;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        outline: 0;
        text-decoration: none;
      }
    }
  }
}

/*********      media    **********/

@media all and (max-width: 960px) {
  .home {
    .index-bottom {
      .video-item {
        width: 470px;
        top: 91px;
        left: 235px;
      }

      .title {
        bottom: 65px;
        left: 236px;

        .number {
          font-size: 60px;
        }

        .name {
          font-size: 24px;
          margin-left: -24px;
        }
      }

      .action {
        top: 48px;
        left: 236px;

        img:first-child {
          margin-right: 10px;
        }

        img {
          width: 30px;
          height: 30px;
        }
      }

      .footer {
        min-width: 960px;
      }
    }
  }
}
/**
 * 浏览器大于1920
 */
@media all and (min-width: 1920px) {
  .home {
    .index-middle {
      .content {
        img {
          width: 636px;
        }

        p {
          font-size: 22px;
          line-height: 48px;
          height: 120px;
        }
      }
    }
    .index-bottom {
      .action {
        top: 92px;
        left: 470px;

        img {
          width: 60px;
          height: 60px;
        }

        img:first-child {
          margin-right: 16px;
        }
      }

      .video-item {
        top: 182px;
        left: 470px;
        width: 938px;

        .dplayer-video-wrap {
          .dplayer-logo {
            img {
              width: 96px;
            }
          }
        }
      }

      .dplayer-controller-mask {
        height: auto;
      }

      .title {
        bottom: 134px;
        left: 490px;

        .number {
          font-size: 122px;
          bottom: 134px;
          width: 110px;
          height: 96px;
        }
      }

      .pagination {
        bottom: 26px;

        .hots {
          width: 18px;
          height: 18px;
        }
      }

      .footer {
        margin: 182px 340px 88px;
      }
    }
  }
}
</style>
